import {useMemo} from 'react';
import {t} from '../../../common/getTranslations';
import {formatWithCommas} from '../../../common/shared/utils/formatWithCommas';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {TabPositionControl} from '../../atoms/TabPositionControl/TabPositionControl';
import {CheckBoxSize} from '../../molecules/CheckBox/CheckBoxSize.enum';
import {BelowDefaultTab} from '../BelowDefaultTab/BelowDefaultTab';
import {
  ContentHomeProductListTabProps,
  TotalListProps,
} from './ContentHomeProductListTabProps.interface';

export function ContentHomeProductListTab({
  children,
  ...props
}: ContentHomeProductListTabProps) {
  const {
    selectedSortOption,
    sortOptionList,
    onClickSortOption,
    isMobile,
    isWebView,
    mode,
    hideBoughtOnlyOption,
    ...rest
  } = props;
  const {boughtOnly, onClickBoughtOnly, totalCount} = (
    mode === 'totalList' ? rest : {}
  ) as TotalListProps;
  const TabContent = useMemo(
    () => (
      <>
        <TabPositionControl
          depth={isMobile ? 2 : 1}
          isMobile={isMobile}
          isWebView={isWebView}
          disabled={!isMobile}
          forceSticky={true}
        >
          <BelowDefaultTab
            className={
              isMobile
                ? 'bg-theme-bg-base px-17pxr'
                : 'bg-theme-bg-surface-alt px-18pxr'
            }
          >
            {mode === 'totalList' && (
              <BelowDefaultTab.TextLabel className="font-small2-bold text-theme-solid-100">
                {t('common_all_count', {
                  values: {
                    value:
                      totalCount === undefined
                        ? '-'
                        : formatWithCommas(totalCount),
                  },
                })}
              </BelowDefaultTab.TextLabel>
            )}
            {mode === 'totalList' && !hideBoughtOnlyOption && (
              <BelowDefaultTab.CheckBox
                isChecked={boughtOnly}
                size={CheckBoxSize.ContentHome}
                {...putTiaraObjectProps({
                  click: {
                    layer1: '필터정렬',
                    copy: boughtOnly ? 'off' : 'on',
                  },
                  customProps: {
                    page_purchased: boughtOnly ? 'y' : 'n',
                  },
                })}
                onClick={e =>
                  LOG_CLICK_EVENT(
                    '구매회차_체크박스_클릭',
                    e,
                    onClickBoughtOnly
                  )
                }
              >
                {t('contenthome_ep_tab_purchased_ep_button')}
              </BelowDefaultTab.CheckBox>
            )}
            {mode === 'selectPurchase' && (
              <BelowDefaultTab.CheckBox
                size={CheckBoxSize.Small}
                isChecked={boughtOnly}
              >
                {t('contenthome_ep_tab_purchased_ep_button')}
              </BelowDefaultTab.CheckBox>
            )}
            <BelowDefaultTab.SelectBox
              iconType={IconType.ContentHomeFilter}
              onClick={onClickSortOption}
            >
              {selectedSortOption?.name ||
                (sortOptionList && sortOptionList[0]?.name) ||
                '-'}
            </BelowDefaultTab.SelectBox>
          </BelowDefaultTab>
        </TabPositionControl>
      </>
    ),
    [
      boughtOnly,
      hideBoughtOnlyOption,
      isMobile,
      isWebView,
      mode,
      onClickBoughtOnly,
      onClickSortOption,
      selectedSortOption?.name,
      sortOptionList,
      totalCount,
    ]
  );

  return isMobile ? (
    <>
      <div className="flex grow flex-col">
        {TabContent}
        {children}
      </div>
    </>
  ) : (
    <div className="rounded-b-12pxr bg-theme-bg-surface-alt">
      {TabContent}
      <div className="flex min-h-[250px] flex-col justify-center">
        {children}
      </div>
    </div>
  );
}
